module.exports = __webpack_public_path__ + "fonts/avenir/1f5c348e-e2a8-45d4-a78f-7f61d7bfd83d.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/avenir/1f5c348e-e2a8-45d4-a78f-7f61d7bfd83d.eot
// module id = 24
// module chunks = 0